import React from 'react'
import { Link } from 'react-router-dom'
import { XCircle } from 'lucide-react'

import {
	Table,
	TableHeader,
	TableBody,
	TableHead,
	TableRow,
	TableCell,
} from 'components/ui/table'

import Button from 'components/Button'
import { StyledDetailsTable } from '../TemplateDetails.style'
import moment from 'moment'

type TemplateDetails = {
	id: string
	key: string
	templateId: string
	textValue: string
	numericValue: string
	currencyValue: string
	dateValue: string
	description: string
	detailType: string
}

export type TableHeaders = { label: string; align?: string }[]

export interface Props {
	details?: TemplateDetails[]
	handleEditDetail: Function
	handleDeleteDetail: Function
	tableHeaders?: TableHeaders
}

const defaultTableHeaders: TableHeaders = [
	{ label: 'Label' },
	{ label: 'Description' },
	{ label: 'Detail Type' },
	{ label: 'Sample Value' },
	{ label: 'Delete', align: 'right' },
]

const TemplateDetailsTable = ({
	details = [],
	handleEditDetail,
	handleDeleteDetail,
	tableHeaders = defaultTableHeaders,
}: Props) => {
	return (
		<StyledDetailsTable data-testid="DetailsTable">
			<div>
				<Table>
					{tableHeaders.length > 0 && (
						<TableHeader>
							<TableRow className="border-b-2 border-[#027fff] hover:bg-transparent">
								{tableHeaders.map((th, i) => (
									<TableHead
										className={`text-gray-700 text-xs font-semibold whitespace-nowrap${th.align === 'right' ? ' text-right' : ''}`}
										key={i}
									>
										{th.label}
									</TableHead>
								))}
							</TableRow>
						</TableHeader>
					)}
					<TableBody>
						{details.map(detail => (
							<TableRow key={detail.id} className="h-7 hover:bg-[#fffbf2] cursor-pointer">
								<TableCell className="py-1 text-sm" onClick={() => handleEditDetail(detail.id)}>
									<Link to="#">{detail.key}</Link>
								</TableCell>
								<TableCell className="py-1 text-sm">
									{detail.description}
								</TableCell>
								<TableCell className="py-1 text-sm">
									{detail.detailType}
								</TableCell>
								<TableCell className="py-1 text-sm">
									{detail.detailType === 'Text'
										? detail.textValue
										: detail.detailType === 'Number'
										? detail.numericValue
										: detail.detailType === 'Currency'
										? `$${detail.currencyValue}`
										: detail.detailType === 'Date'
										? moment(detail.dateValue).format('MM/DD/YYYY')
										: null}
								</TableCell>
								<TableCell className="py-1 text-sm text-right">
									<div className="edit-button">
										<Button
											onClick={() => handleDeleteDetail(detail.id)}
											variant="ghost-red"
											isOutline
											aria-label="Delete"
										>
											<XCircle className="w-4 h-4" />
										</Button>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</div>
		</StyledDetailsTable>
	)
}

export default TemplateDetailsTable
